import script from "./ServiceChannelStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceChannelStatistics.vue?vue&type=script&setup=true&lang=js"

import "./ServiceChannelStatistics.vue?vue&type=style&index=0&id=aa427646&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa427646"]])

export default __exports__